import { defineStore } from 'pinia'
import axios from '@/utils/axios'

const CACHE_TIME = 30 * 60 * 1000 

export const useCountryStore = defineStore('country', {
  state: () => ({
    list: [],
    lastFetch: 0
  }),

   persist: {
    paths: ['list', 'lastFetch']  
  },

  actions: {
    async loadCountries(force = false) {
      const now = Date.now()
      const isFresh = this.lastFetch && (now - this.lastFetch) < CACHE_TIME

      // Data hai + fresh hai -> API skip
      if (!force && isFresh && this.list.length) {
        return this.list
      }

      try {
        const response = await axios.get('/countries')
        this.list = response.data.data
        this.lastFetch = now
      } catch (error) {
        console.log(error.message)
      }
      return this.list
    },
    async fetchCountries(force = false) {
      const list = await this.loadCountries(force);
      return { data: { data: list } };
    },
      clearCache() {
        this.list = []
        this.lastFetch = 0
    }
  }
})